module.exports = __webpack_public_path__ + "static/media/online_world.5b81eb51.svg";